var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mahasiswa"},[_c('h1',[_vm._v("Mahasiswa")]),_c('v-card',[_c('v-card-title',[_vm._v("Data Mahasiswa")]),_c('v-divider'),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.listMahasiswa,"items-per-page":5}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }